import * as React from 'react';
import { useEffect, useState } from "react";
import { ApplicationState } from "../../redux/reducers";
import { connect } from "react-redux"
import ServicioAdicional from "./ServicioAdcional";
import { Box, Grid } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { ICategoriaServicio } from "../../redux/types/servicioAdicionalType";
import {IServicioAdicional, ServicioAdicional as Servicio} from "../../entities/catalogos/ServicioAdicional";
import Help, { IHelp } from '../help/Help';
import {enums} from "../../enums/enums";
import { traducirLabel, traducirMessage } from '../../blocks/traductor';

interface OwnProps {

    servicios: Servicio[]
    onSelect: (servicio: Servicio) => void
    cotizacionId: number
    solicitud: any
    esSeccionServicios: boolean
    esOrigen: boolean
    paisId: number
}

interface StateProps {
    categorias: ICategoriaServicio[],
    ayuda: IHelp
}

type Props = StateProps & OwnProps

const categoriaComentario = new Map([
    /*
    [traducirMessage(179), "ServiciosAdicionalesManiobras"],
    [traducirLabel(242), "ServiciosAdicionalesPuertos"],
    [traducirMessage(236), "ServiciosAdicionalesPostServicio"],
    [traducirLabel(247), "ServiciosAdicionalesPuntoCliente"]
    */
    ["Maniobra", traducirMessage(168)],
    ["Puertos", traducirMessage(170)],
    ["Post Servicio", traducirMessage(172)],
    ["Punto con Cliente", traducirMessage(171)]
]);

const ServicioAdicionalLista = ({ categorias, servicios, onSelect, cotizacionId, esSeccionServicios, solicitud,
                                    paisId, esOrigen, ayuda }: Props) => {
    const paisIdOrigen = esOrigen? paisId: solicitud.coloniaOrigen?.pais?.id;
    const paisIdDestino = !esOrigen? paisId: solicitud.coloniaDestino?.pais?.id;
    const ocultarServiciosCruce = !esSeccionServicios && !esOrigen && paisIdOrigen === paisIdDestino;
    const idsServiciosCruce = servicios.filter(e => e.nombre.includes("FLETE CRUCE FRONTERIZO")).map(e => e.id);
    const [categoriasSeccion, setCategoriasSeccion] = useState<ICategoriaServicio[]>([{
        id: 0,
        nombre: "",
        expanded: true,
        etiquetaCategoriaServicioAdicional: []
    }]);

    useEffect(() => {
        if (servicios != null && servicios.length > 0) {
            const categoriasId = [...new Set(servicios.map(sa => sa.categoriaId))];
            if (esSeccionServicios && categoriasId.length && categoriasId[0] !== undefined) {
                setCategoriasSeccion(categorias.filter(c => categoriasId.includes(c.id)));
            }
        }
    }, [servicios, categorias]);


    const handleAccordion = (id: number) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setCategoriasSeccion(categoriasSeccion.map(c => {
            return c.id !== id ? c : { ...c, expanded: isExpanded }
        }));
    };

    const mostrarServicio = (servicio: IServicioAdicional, categoriaId: number | undefined): boolean => {
        let idsExcluidosOrigenDestino = [6, 9, 12, 47];
        let isShowable =false;
        if(ocultarServiciosCruce){
            idsExcluidosOrigenDestino = [...idsExcluidosOrigenDestino, ...idsServiciosCruce];
            isShowable = idsExcluidosOrigenDestino.includes(servicio.id);
        }
        else
        {
            isShowable = !idsExcluidosOrigenDestino.includes(servicio.id);
        }
        
        return esSeccionServicios ? categoriaId === servicio.categoriaId : isShowable;
    }

    return (<>
        {categoriasSeccion.length && categoriasSeccion.map((c,index) => {
            return (
                <Accordion key={index} expanded={c.expanded} onChange={handleAccordion(c.id)} style={{ marginBottom: "1.5rem" }} >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Box display="flex">
                            {esSeccionServicios && localStorage.getItem("idioma") === 'en-US' &&
                            <Box flexGrow={1}>
                                <b style={{ paddingLeft: c.nombre === "Mercancia"? "0px": "30px" }}>{c.etiquetaCategoriaServicioAdicional.nombre}</b>
                            </Box>
                            }
                            {esSeccionServicios && localStorage.getItem("idioma") !== 'en-US' &&
                            <Box flexGrow={1}>
                                <b style={{ paddingLeft: c.nombre === "Mercancia"? "0px": "30px" }}>{c.nombre}</b>
                            </Box>
                            }
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box display="flex">
                            <Box>
                                {esSeccionServicios && categoriaComentario.has(c.nombre) &&
                                <Help comments={c.nombre === "Maniobra" ? traducirMessage(168) : c.nombre === "Puertos" ? traducirMessage(170) : c.nombre === "Post Servicio" ? traducirMessage(172) : c.nombre === "Punto con Cliente" ? traducirMessage(171) : "" } size="small"
                                      customStyle={{ bottom: "10px", left: "-15px" }}/>
                                }
                            </Box>
                        </Box>
                        <Grid container spacing={1}>
                            {
                                servicios.map(sa =>
                                    mostrarServicio(sa, c.id) &&
                                    <ServicioAdicional key={sa.id} value={sa} onSelect={onSelect}
                                                       cotizacionId={cotizacionId}/>
                                )
                            }
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            )
        })
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    categorias: state.categoriasServicios,
    solicitud: state.solicitud,
    ayuda: state.ayuda
});

export default connect(mapStateToProps)(ServicioAdicionalLista);
